import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { CardNavigationService } from '../../../services/card-navigation.service';

@Component({
    selector: '.o-hightlight'
})
export class HightlightComponent extends ComponentBase<HTMLElement> {

    public constructor(node: HTMLElement, private _cardNavigationService: CardNavigationService) {
        super(node);
    }

    public onInit(): void {
        this._cardNavigationService.enableRowNavigation(this._node);
    }

    public dispose(): void {
        this._cardNavigationService.disableNavigation(this._node);
        super.dispose();
    }
}